import Style from './style'

const DefaultButton = ({
	children,
	clickEvent,
	minor,
	small,
	deactive,
	fitWidth,
	expandHeight,
	loading = false,
	style,
}) => {
	return (
		<Style.Btn
			onClick={!deactive && !loading ? clickEvent : undefined}
			$minor={minor}
			$small={small}
			$disabled={deactive || loading}
			$fitWidth={fitWidth}
			$expandHeight={expandHeight}
			$loading={loading}
			style={style}
		>
			{children}
			{loading && (
				<Style.LoadingOverlay>
					<Style.LoadingSpinner />
				</Style.LoadingOverlay>
			)}
		</Style.Btn>
	)
}

export default DefaultButton
